import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "columns is-multiline" }
const _hoisted_2 = { class: "column is-full" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = { class: "column is-one-quarter-desktop is-full-tablet" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = { class: "box-title" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Explore", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "is-size-4 has-text-centered is-marginless is-paddingless"
}
const _hoisted_10 = {
  key: 1,
  class: "is-size-5 has-text-centered is-marginless is-paddingless"
}

import ComparisonChart from "../../Modules/AttributionComparison/Chart.vue";
import ComparisonBreadcrumb from "../../Modules/AttributionComparison/Breadcrumb.vue";
import ComparisonControls from "../../Modules/AttributionComparison/Controls.vue";
import OuterSection from "../../Elements/OuterSection.vue";
import { UseAttributionComparison } from "./Hooks/UseAttributionComparison";
import { UseUrlBuilder } from "../../Helper/Stateful/UseUrlBuilder";
import {
  // SetTaxonomyHelper,
  UseTaxonomyHelper,
} from "../../Helper/Stateful/UseTaxonomyHelper";
import { computed, onBeforeMount, onMounted, watch } from "vue";
import { UseAxiosErrorHelper } from "../../Helper/ThirdParty/UseAxiosErrorHelper";
import { useRoute } from "vue-router";
import { UseStringHelper } from "../../Helper/Functional/UseStringHelper";
import { PerformanceTableAndChartData } from "../../Helper/Stateful/PerformanceTableAndChartData";
import { chunk, orderBy } from "lodash";
import { storeToRefs } from "pinia";
import { UseDateStore } from "../../Modules/State/Stores/DateStore";
//Get Urls

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

UseAxiosErrorHelper();
const tableDataType = "table/single";
const { validateInternalParameter } = UseStringHelper();
const { query } = useRoute();
UseAxiosErrorHelper();

const {
  taxonomyOne: cpTaxonomyOne,
  taxonomyTwo: cpTaxonomyTwo,
  taxonomyThree: cpTaxonomyThree,
  currentTaxonomyInteger,
  fetchNavigationUrlHandler,
  documentTitleHandler,
  taxonomyRouteParams,
} = UseTaxonomyHelper();

//Get Taxonomy Level
taxonomyRouteParams();

const { setBasicTableUrl, buildAnyInitialUrl } = UseUrlBuilder({
  dataSet: "",
});
//Get some hooky-wooky shizzle
const {
  comparison,
  headers,
  firstMetric,
  secondMetric,
  monetaryMetrics,
  page,
  perPage,
  sortMetric,
  sortMetricDirection,
  fetchDifferenceClass,
  fetchDifferenceMonetary,
  fetchDifferencePercentage,
  makeMyData,
} = UseAttributionComparison();

//Get some data?
const {
  tableData: data,
  tableLoading: loading,
  loadTableData,
  clearTableData,
} = PerformanceTableAndChartData();

onBeforeMount(() => {
  clearTableData();
});

onMounted(() => {
  document.title = documentTitleHandler("Attribution Comparison");
  setBasicTableUrl(buildAnyInitialUrl("performanceTable", tableDataType));
  loadTableData();
});
const { getDateFrom, getDateTo } = storeToRefs(UseDateStore());
watch([getDateFrom, getDateTo], () => {
  setBasicTableUrl(buildAnyInitialUrl("performanceTable", tableDataType));
  clearTableData();
  loadTableData();
});

const sortedData = computed(() => {
  return data.value
    ? orderBy(data.value, sortMetric.value, sortMetricDirection.value as "asc" | "desc")
    : [];
});
const chunkedData = computed(() => {
  return chunk(sortedData.value, perPage.value);
});
const pageData = computed(() => {
  return data.value ? chunkedData.value[page.value - 1] : [];
});

onMounted(() => {
  comparison.value = (query.comparisonMetric as string) || "lcr";
});

const metrics = computed(() => {
  if (comparison.value === "lcr") {
    return ["taxonomy_1", "attributed_revenue", "last_click_revenue"];
  } else {
    return ["taxonomy_1", "attributed_revenue", "total_cost"];
  }
});

const fetchNavigationUrl = computed(() =>
  fetchNavigationUrlHandler("/attribution-comparison")
);

return (_ctx: any,_cache: any) => {
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(OuterSection, { ref: "breakdownTaxonomyOneSection" }, {
      default: _withCtx(() => [
        _createVNode(_component_o_loading, {
          active: _unref(loading),
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null))
        }, null, 8, ["active"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(ComparisonBreadcrumb, {
                taxonomyOne: _unref(cpTaxonomyOne),
                taxonomyTwo: _unref(cpTaxonomyTwo),
                taxonomyThree: _unref(cpTaxonomyThree)
              }, null, 8, ["taxonomyOne", "taxonomyTwo", "taxonomyThree"]),
              _createVNode(ComparisonControls, {
                headers: _unref(headers),
                metrics: _unref(metrics),
                "sort-metric": _unref(sortMetric),
                "onUpdate:sort-metric": _cache[1] || (_cache[1] = ($event: any) => (_isRef(sortMetric) ? (sortMetric).value = $event : null)),
                comparison: _unref(comparison),
                "onUpdate:comparison": _cache[2] || (_cache[2] = ($event: any) => (_isRef(comparison) ? (comparison).value = $event : null)),
                "sort-direction": _unref(sortMetricDirection),
                "onUpdate:sort-direction": _cache[3] || (_cache[3] = ($event: any) => (_isRef(sortMetricDirection) ? (sortMetricDirection).value = $event : null)),
                page: _unref(page),
                "onUpdate:page": _cache[4] || (_cache[4] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
                "per-page": _unref(perPage),
                "onUpdate:per-page": _cache[5] || (_cache[5] = ($event: any) => (_isRef(perPage) ? (perPage).value = $event : null)),
                records: _unref(sortedData).length,
                "onUpdate:records": _cache[6] || (_cache[6] = ($event: any) => ((_unref(sortedData).length) = $event))
              }, null, 8, ["headers", "metrics", "sort-metric", "comparison", "sort-direction", "page", "per-page", "records"])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData), (comparisonData) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(comparisonData[`taxonomy_${_unref(currentTaxonomyInteger)}`]), 1),
                  (_unref(currentTaxonomyInteger) < 4)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: 
                    _unref(fetchNavigationUrl) +
                    _unref(validateInternalParameter)(
                      comparisonData[`taxonomy_${_unref(currentTaxonomyInteger)}`]
                    ) +
                    (_unref(comparison) == 'lcr' ? '' : '?comparisonMetric=' + _unref(comparison))
                  ,
                        class: "is-pulled-right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_o_icon, {
                            icon: "chevron-right",
                            size: "is-small"
                          }),
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_8,
                (_unref(comparison) === 'lcr')
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_9, [
                      _createElementVNode("span", {
                        class: _normalizeClass([_unref(fetchDifferenceClass)(comparisonData)])
                      }, _toDisplayString(_unref(fetchDifferenceMonetary)(comparisonData)), 3)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(comparison) === 'lcr')
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_10, [
                      _createElementVNode("span", {
                        class: _normalizeClass([_unref(fetchDifferenceClass)(comparisonData)])
                      }, _toDisplayString(`(${_unref(fetchDifferencePercentage)(comparisonData)})`), 3)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(ComparisonChart, {
                  data: _unref(makeMyData)(comparisonData),
                  "monetary-metrics": _unref(monetaryMetrics),
                  "first-metric": _unref(firstMetric),
                  "onUpdate:first-metric": _cache[7] || (_cache[7] = ($event: any) => (_isRef(firstMetric) ? (firstMetric).value = $event : null)),
                  "second-metric": _unref(secondMetric),
                  "onUpdate:second-metric": _cache[8] || (_cache[8] = ($event: any) => (_isRef(secondMetric) ? (secondMetric).value = $event : null)),
                  headers: _unref(headers),
                  "onUpdate:headers": _cache[9] || (_cache[9] = ($event: any) => (_isRef(headers) ? (headers).value = $event : null))
                }, null, 8, ["data", "monetary-metrics", "first-metric", "second-metric", "headers"])
              ])
            ]))
          }), 256))
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})